"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _Content = _interopRequireDefault(require("../common/Content"));

var _axios = _interopRequireDefault(require("axios"));

var _TopicPublicTags = _interopRequireDefault(require("../topic-list-view/TopicPublicTags"));

var _common = require("@insided/shared/utils/common");

var _contentType = require("@insided/shared/utils/contentType");

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dateFormatDestination = _interopRequireDefault(require("../utils/dateFormatDestination"));

var _attachmentService = require("@insided/deprecated-services/attachmentService");

var _Attachments = _interopRequireDefault(require("@insided/destination/modules/Content/TopicView/Post/Attachments"));

var _MetaInfo = _interopRequireDefault(require("@insided/deprecated-preact-components/User/MetaInfo"));

var _Badges = _interopRequireDefault(require("@insided/deprecated-preact-components/User/Badges"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ProductUpdateTopicView = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductUpdateTopicView, _Component);

  var _super = _createSuper(ProductUpdateTopicView);

  function ProductUpdateTopicView() {
    var _this$props$topic$lik;

    var _this;

    (0, _classCallCheck2.default)(this, ProductUpdateTopicView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isProductAreasEnabled", _common.common.isModuleActive('productAreas'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      content: _this.props.topic.content,
      isCurrentUserLiked: !!_this.props.currentUser && _this.props.currentUser.id !== null && ((_this$props$topic$lik = _this.props.topic.likedBy) === null || _this$props$topic$lik === void 0 ? void 0 : _this$props$topic$lik.includes(_this.props.currentUser.id.toString())),
      likedUsers: {},
      tags: _this.props.topic.tags,
      attachments: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "content", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLikeStatusToggle", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var currentUser, isCurrentUserLiked, currentUserId;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentUser = _this.props.currentUser;
              isCurrentUserLiked = _this.state.isCurrentUserLiked;

              if (currentUser) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              currentUserId = currentUser.id;

              if (currentUser) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              if (isCurrentUserLiked) {
                _this.setState(function (prevState) {
                  delete prevState.likedUsers[currentUserId];
                  return {
                    likedUsers: prevState.likedUsers,
                    isCurrentUserLiked: false
                  };
                });
              } else {
                _this.setState(function (prevState) {
                  return {
                    likedUsers: _objectSpread(_objectSpread({}, prevState.likedUsers), {}, (0, _defineProperty2.default)({}, currentUserId, currentUser)),
                    isCurrentUserLiked: true
                  };
                });
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (content, attachments) {
      _this.setState({
        content: content,
        attachments: attachments
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ProductUpdateTopicView, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$props$topic, id, likedBy, content, attachments, res;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props$topic = this.props.topic, id = _this$props$topic.id, likedBy = _this$props$topic.likedBy, content = _this$props$topic.content;
                _context2.next = 3;
                return (0, _attachmentService.getAttachmentsForTopic)(String(id), _contentType.CONTENT_TYPE_PRODUCT_UPDATE);

              case 3:
                attachments = _context2.sent;
                this.setState({
                  attachments: attachments
                });

                if (!(likedBy !== null && likedBy !== void 0 && likedBy.length)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return _axios.default.post('/member/getUsersById', {
                  ids: likedBy !== null && likedBy !== void 0 ? likedBy : []
                });

              case 8:
                res = _context2.sent;
                this.setState({
                  likedUsers: res.data
                });

              case 10:
                this.content.current = content;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          topic = _this$props.topic,
          attachmentCdn = _this$props.attachmentCdn,
          authorData = _this$props.authorData;
      var _this$state = this.state,
          tags = _this$state.tags,
          attachments = _this$state.attachments,
          content = _this$state.content;

      var _ref2 = topic || {},
          author = _ref2.author,
          publishedAt = _ref2.publishedAt,
          topicId = _ref2.id;

      var _ref3 = author || {},
          userId = _ref3.id,
          reputation = _ref3.reputation;

      var authorInfo = userId && authorData ? authorData[userId] : null;

      var _ref4 = authorInfo || {},
          badges = _ref4.badges,
          userLevel = _ref4.userLevel;

      var recentBadge = badges === null || badges === void 0 ? void 0 : badges[badges.length - 1];
      var user = userId && authorInfo ? _objectSpread(_objectSpread({}, authorInfo), {
        reputation: reputation
      }) : _objectSpread(_objectSpread({}, author), {
        name: author.username
      });
      return (0, _preact.h)("div", null, (0, _preact.h)(_preactPortal.default, {
        into: ".list-item--publish-date"
      }, (0, _preact.h)(_Tooltip.default, {
        withArrow: true,
        trigger: (0, _preact.h)("time", null, " ", _common.common.relativeDate(publishedAt), " "),
        tooltipMessage: (0, _preact.h)("div", {
          className: (0, _classnames.default)('tooltip__content', 'tooltip__content--publish-date', 'js-tooltip-content', 'position--bottom')
        }, (0, _dateFormatDestination.default)(new Date(publishedAt)))
      })), (0, _preact.h)("div", {
        id: "post".concat(topic.id),
        className: (0, _classnames.default)('post', 'box__pad', 'qa-topic-post-box', 'post--odd js-toggle-target')
      }, (0, _preact.h)("div", {
        className: "post__user__info"
      }, (0, _preact.h)(_UserAvatar.default, {
        user: user,
        extraClass: "avatar avatar--responsive",
        showRank: true
      }), (0, _preact.h)("div", {
        className: "reputation"
      }, (0, _preact.h)("div", {
        className: "reputation__level--".concat(userLevel)
      })), badges && badges.length > 0 && (0, _preact.h)(_Badges.default, {
        recentBadge: recentBadge,
        count: badges.length
      })), (0, _preact.h)(_MetaInfo.default, {
        user: user
      }), (0, _preact.h)("div", null, (0, _preact.h)(_Content.default, {
        content: content !== null && content !== void 0 ? content : '',
        className: (0, _classnames.default)('post__content', 'qa-topic-post-content', 'post__content--new-editor')
      })), (0, _preact.h)("div", {
        className: "post__footer qa-topic-post-footer"
      }, attachments.length > 0 && (0, _preact.h)(_Attachments.default, {
        attachments: attachments,
        attachmentCdn: attachmentCdn
      }), this.isProductAreasEnabled ? (0, _preact.h)(_TopicPublicTags.default, {
        topicId: topicId,
        contentType: _contentType.CONTENT_TYPE_PRODUCT_UPDATE,
        tags: tags,
        canUserEdit: false,
        onChange: function onChange() {}
      }) : null)));
    }
  }]);
  return ProductUpdateTopicView;
}(_preact.Component);

var _default = ProductUpdateTopicView;
exports.default = _default;